export default __webpack_public_path__ + "static/media/Badge_blue.1203e204.svg";